import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import "./index.css";
import { DatesProvider } from "@mantine/dates";
import "@mantine/core/styles.css"; //import Mantine V7 styles needed by MRT
import "@mantine/dates/styles.css"; //if using mantine date picker features
import "mantine-react-table/styles.css"; //import MRT styles

import "dayjs/locale/vi";
import { useNavigation } from "react-router-dom";
import { Loading } from "./_base/component/_layout/Loading";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);



// dayjs.extend(utc);
// dayjs.extend(timezone);
// dayjs.extend(customParseFormat)
// dayjs.tz.setDefault("America/Saigon");
// dayjs.locale("vi");
console.log(dayjs.tz.guess());

// MjM5MkAzMjM0MkUzMTJFMzlZRnNmeEdKa0haRGU0S0MyZUR3b05vcDJFNURBbnFRTi9STUVidExydWswPQ==
// ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Qd0ViWH1ecnJQRWJd
// Mgo+DSMBMAY9C3t2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdERiXXtfc3BVQmFV
root.render(
  <React.StrictMode>
    <MantineProvider>
      <DatesProvider settings={{ locale: "vi", timezone: "Asia/Ho_Chi_Minh" }}>
        <ModalsProvider>
          <Notifications
            zIndex={999999999}
            position="top-center"
            autoClose={3000}
          />
          <App />
        </ModalsProvider>
      </DatesProvider>
    </MantineProvider>
  </React.StrictMode>
);
reportWebVitals();
